<template>
  <auth-layout pageClass="login-page">
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-lg-4 col-md-6 col-sm-8">
        <ValidationObserver v-slot="{ handleSubmit }">
          <form class="label-control" @submit.prevent="handleSubmit(signIn)">
            <card>
              <div class="card-header" slot="header">
                <h3
                  class="card-title text-center"
                  style="color: #d9d9d9; font-weight: bold"
                >
                  Login
                </h3>
              </div>
              <div>
                <ValidationProvider
                  name="Email"
                  rules="required|email"
                  tag="div"
                  class="mb-3"
                  v-slot="{ errors }"
                >
                  <label>Email Address</label>
                  <input
                      v-model="email"
                      type="email"
                      class="form-control login-inputs-background"
                      placeholder="Enter your email"
                  />
                  <div
                    v-if="errors.length"
                    class="text-danger"
                    style="font-size: 0.875em"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  name="Password"
                  rules="required|min:5"
                  tag="div"
                  class="mb-3"
                  v-slot="{ errors }"
                >
                  <label>Password</label>
                  <div class="position-relative">
                    <input
                        v-model="password"
                        :type="passwordInputType"
                        class="form-control login-inputs-background"
                        placeholder="Enter your password"
                    />
                    <i
                        :class="passwordVisible ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"
                        @click="togglePasswordVisibility"
                        class="position-absolute"
                        style="
                          top: 50%;
                          right: 12px;
                          transform: translateY(-50%);
                          cursor: pointer;
                          color: #666;
                        "
                        aria-hidden="true"
                    ></i>
                  </div>
                  <div
                    v-if="errors.length"
                    class="text-danger"
                    style="font-size: 0.875em"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </div>
              <div class="text-center">
                <button
                  type="submit"
                  class="login-btn btn-fill btn-info btn-wd"
                >
                  Login
                </button>
                <br />
                <!--                  <div class="forgot">-->
                <!--                    <router-link to="/register" class="card-category">-->
                <!--                      Forgot your password?-->
                <!--                    </router-link>-->
                <!--                  </div>-->
              </div>
            </card>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </auth-layout>
</template>
<script>
import AuthLayout from "../components/AuthLayout.vue";
import { extend } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";
import CommonHandler from "@/serviceHandlers/CommonHandler";
import { useLoginStore } from "src/stores/loginStore";

const apiService = new CommonHandler();

extend("email", email);
extend("required", required);
extend("min", min);

extend("password_match", {
  params: ["target"],
  validate(value, { target }) {
    return value === target;
  },
  message: "Passwords do not match",
});

export default {
  name: 'LoginPage',
  components: {
    AuthLayout,
  },
  data() {
    return {
      email: "",
      password: "",
      passwordVisible: false,
      passwordInputType: "password",
    };
  },
  mounted() {
    this.store = useLoginStore();
  },
  methods: {
    togglePasswordVisibility() {
      switch (this.passwordInputType) {
        case "password":
          this.passwordInputType = "text";
          this.passwordVisible = true;
          break;
        case "text":
          this.passwordInputType = "password";
          this.passwordVisible = false;
          break;
      }
    },
    async signIn() {
      const login = {
        email: this.email,
        password: this.password,
      };
      this.$spinner.show();
      apiService
        .login(login, this.$router, this.store, [])
        .then((response) => {
          if (response) {
            if (this.store.getLoggedIn) {
              this.$router.push({
                name: "Availity Page",
              });
            } else if (!response.success) {
              this.$notifyError("Incorrect username or password");
            }
          } else {
            this.$notifyError(
              "There was an error logging in. Please try again",
            );
          }
        })
        .catch((error) => {
          this.$notifyError(
            `There was an error logging in. Please try again ${error}`,
          );
        });
      this.$spinner.hide();
    },
  },
};
</script>
<style scoped>
.login-inputs-background{
  width: 100% !important;
  background-color: #ffffff !important;
  color: #000000 !important;
  border: 1px solid #000000 !important;
  border-radius: 12px !important;
  padding: 12px 16px !important;
  font-size: 14px !important;
  transition: all 0.3s ease !important;
}

.login-inputs-background:focus {
  background-color: #ffffff !important;
  color: #000000 !important;
  border: 2px solid #000000 !important;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1) !important;
  outline: none !important;
}

.card-header {
  background: #ffffff !important;
  color: #000000 !important;
  height: 60px;
  font-family: "Playfair Display", serif;
  border: none !important;
  border-radius: 16px !important;
}

.card-title {
  font-family: "Playfair Display", serif;
  color: #000000 !important;
}

.login-btn {
  background-color: #ffffff;
  padding-bottom: 7px;
  padding-top: 5px;
  border-radius: 16px;
  border: 1px solid #000000;
  color: #000000 !important;
  font-family: "Nimbus Sans Light", sans-serif;
  font-weight: bold;
}

.login-btn:hover {
  background-color: #ffffff;
  color: #000000 !important;
  border: 2px solid #000000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

label {
  color: #000000 !important;
  font-family: "Nimbus Sans Light", sans-serif;
  font-size: 14px !important;
  letter-spacing: 0.05rem !important;
}
</style>
